import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import WarningIcon from '@mui/icons-material/Warning'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type React from 'react'

interface ConfirmationItemProps {
  label: string
  isConfirmed?: boolean
}

const ConfirmationItem: React.FC<ConfirmationItemProps> = ({ label, isConfirmed }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography variant="body2" fontWeight="bold" fontSize="14px">
      {label}:
    </Typography>
    <Typography variant="body2" fontSize="14px">
      {isConfirmed ? 'Confirmed' : 'Not confirmed'}
    </Typography>
    {isConfirmed ? (
      <CheckCircleIcon sx={{ color: 'success.main' }} />
    ) : (
      <WarningIcon sx={{ color: 'warning.main' }} />
    )}
  </Box>
)

interface ConfirmationsProps {
  identityConfirmed?: boolean
  residencyConfirmed?: boolean
}

const Confirmations: React.FC<ConfirmationsProps> = ({
  identityConfirmed,
  residencyConfirmed,
}) => (
  <Box
    sx={{
      background: '#f2f1f1',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      gap: { xs: 4, sm: 6, md: 10 },
      padding: '20px',
      my: 2,
    }}
  >
    <ConfirmationItem label="Identity" isConfirmed={identityConfirmed} />
    <ConfirmationItem label="Residency" isConfirmed={residencyConfirmed} />
  </Box>
)

export default Confirmations
